
export const sessionizeUrl = 'https://sessionize.com/droidkaigi2018/'



// WEBPACK FOOTER //
// ./src/utils/const.js